module.exports = __webpack_public_path__ + "static/media/pdp_paperDoubleThick.e736b419.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/pdp-hover/pdp_paperDoubleThick.jpg
// module id = 1111
// module chunks = 51